import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { Home, ArrowRight } from 'lucide-react';

const NotFoundPage = () => (
  <Layout>
    <SEO title="Page Not Found | Website Symphony" description="The page you are looking for does not exist. Return home or explore our web design services." noIndex />
    <section className="min-h-[60vh] flex items-center justify-center bg-white py-20">
      <div className="text-center max-w-2xl mx-auto px-6">
        <div className="text-[#D9A04A] text-8xl md:text-9xl font-extrabold leading-none">404</div>
        <h1 className="text-[#2C5F66] text-3xl md:text-4xl font-extrabold mt-4">Looks like this page wandered off</h1>
        <p className="text-gray-600 mt-4">The page you are looking for might have moved or never existed. Try one of these instead:</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 bg-[#2C5F66] hover:bg-[#244e54] text-white font-semibold px-6 py-3 rounded-md transition-colors"><Home size={16} /> Home</Link>
          <Link to="/web-design" className="inline-flex items-center gap-2 bg-white border border-[#2C5F66] text-[#2C5F66] hover:bg-[#2C5F66] hover:text-white font-semibold px-6 py-3 rounded-md transition-colors">Web Design <ArrowRight size={16} /></Link>
          <Link to="/portfolio" className="inline-flex items-center gap-2 bg-white border border-[#2C5F66] text-[#2C5F66] hover:bg-[#2C5F66] hover:text-white font-semibold px-6 py-3 rounded-md transition-colors">Portfolio <ArrowRight size={16} /></Link>
          <Link to="/blog" className="inline-flex items-center gap-2 bg-white border border-[#2C5F66] text-[#2C5F66] hover:bg-[#2C5F66] hover:text-white font-semibold px-6 py-3 rounded-md transition-colors">Blog <ArrowRight size={16} /></Link>
        </div>
      </div>
    </section>
  </Layout>
);

export default NotFoundPage;
